import { SubmenuNavRef } from '@components/Nav/SubmenuNav';

import {
  ANNUAL_MOBILE_STEPS,
  ANNUAL_MOBILE_STEPS_ARTICLE,
  ANNUAL_STEPS,
  ANNUAL_STEPS_ARTICLE,
  ONBOARDING_ANCHOR_REGISTER_EVENT,
  ONBOARDING_MORE_NAV_REGISTER_EVENT,
  ONBOARDING_PRO_NAV_REGISTER_EVENT,
  ONBOARDING_SETTINGS_NAV_REGISTER_EVENT,
  ONBOARDING_STEP_CHANGE_EVENT,
  PRO_MOBILE_STEPS,
  PRO_MOBILE_STEPS_ARTICLE,
  PRO_STEPS,
  PRO_STEPS_ARTICLE,
  onboardingRegistry,
} from './constants';

export function isElementVisible(el: HTMLElement) {
  const style = window.getComputedStyle(el);
  return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
}

export function applyZIndex(el: HTMLElement, zIndex: number) {
  el.style.zIndex = String(zIndex);
}

export function clearZIndex(el: HTMLElement | null) {
  if (!el) return;
  el.style.zIndex = '';
}

export const isArticlePage = (pathname: string) =>
  pathname.startsWith('/articles/') && pathname.length > '/articles/'.length;

export const getSteps = (isProSubscriber: boolean, isMobile: boolean, isArticlePage: boolean) => {
  if (isMobile) {
    return isProSubscriber
      ? isArticlePage
        ? PRO_MOBILE_STEPS_ARTICLE
        : PRO_MOBILE_STEPS
      : isArticlePage
      ? ANNUAL_MOBILE_STEPS_ARTICLE
      : ANNUAL_MOBILE_STEPS;
  }
  return isProSubscriber
    ? isArticlePage
      ? PRO_STEPS_ARTICLE
      : PRO_STEPS
    : isArticlePage
    ? ANNUAL_STEPS_ARTICLE
    : ANNUAL_STEPS;
};

/* -----------------------------
 * Step control
 * ----------------------------- */
export const setActiveOnboardingStep = (step: string | null) => {
  window.dispatchEvent(
    new CustomEvent(ONBOARDING_STEP_CHANGE_EVENT, {
      detail: { activeStep: step },
    })
  );
};

/* -----------------------------
 * Nav refs
 * ----------------------------- */
export const registerProNavRef = (ref: SubmenuNavRef | null) => {
  onboardingRegistry.proNavRef.current = ref;
  window.dispatchEvent(
    new CustomEvent(ONBOARDING_PRO_NAV_REGISTER_EVENT, {
      detail: { ref },
    })
  );
};

export const registerMoreNavRef = (ref: SubmenuNavRef | null) => {
  onboardingRegistry.moreNavRef.current = ref;
  window.dispatchEvent(
    new CustomEvent(ONBOARDING_MORE_NAV_REGISTER_EVENT, {
      detail: { ref },
    })
  );
};

export const registerSettingsNavRef = (ref: SubmenuNavRef | null) => {
  onboardingRegistry.settingsNavRef.current = ref;
  window.dispatchEvent(
    new CustomEvent(ONBOARDING_SETTINGS_NAV_REGISTER_EVENT, {
      detail: { ref },
    })
  );
};

export const getProNavRef = (): SubmenuNavRef | null => onboardingRegistry.proNavRef.current;
export const getMoreNavRef = (): SubmenuNavRef | null => onboardingRegistry.moreNavRef.current;
export const getSettingsNavRef = (): SubmenuNavRef | null =>
  onboardingRegistry.settingsNavRef.current;

/* -----------------------------
 * Anchors
 * ----------------------------- */
export const registerOnboardingAnchor = (stepId: string, element: HTMLElement | null) => {
  onboardingRegistry.anchors[stepId] = element;

  window.dispatchEvent(
    new CustomEvent(ONBOARDING_ANCHOR_REGISTER_EVENT, {
      detail: { stepId, element },
    })
  );
};

export const getOnboardingAnchor = (stepId: string) => onboardingRegistry.anchors[stepId] ?? null;
